module.exports = __webpack_public_path__ + "assets/img/cut1.9a47023e.png";